<script lang="ts">
  import { dev } from '$app/environment';
  import { page } from '$app/stores';

  import Page404 from '$components/404.svelte';
</script>

{#if $page.status === 404}
  <Page404 />
{:else if dev}
  {#if $page.error?.frame}
    <pre>{$page.error.frame}</pre>
  {/if}
  {#if $page.error?.stack}
    <pre>{$page.error.stack}</pre>
  {/if}
{/if}
